import { COLOR_BACKGROUNDS } from '@shared/websiteTemplates/websiteTemplates.colors';
import { COLOR_FACET } from '../Filters.constants';

const normalizeColorName = (name: string) => name.replace(/[\s_-]/g, '').toLowerCase();

/** Website-template swatch backgrounds keyed by normalized color name (`rosegold`, `blue`…). */
const BACKGROUND_BY_NORMALIZED_NAME: ReadonlyMap<string, string> = new Map(Object.entries(COLOR_BACKGROUNDS).map(([name, background]) => [normalizeColorName(name), background]));

/**
 * CSS background for a `color:<name>` facet option's swatch, reusing the website templates
 * gallery's palette so the two galleries' Color filters look alike. `undefined` for a
 * non-color option or a color the palette doesn't define (the row then shows no swatch).
 */
export const colorSwatchBackground = (compositeCode: string): string | undefined => {
  const prefix = `${COLOR_FACET}:`;
  if (!compositeCode.startsWith(prefix)) return undefined;
  return BACKGROUND_BY_NORMALIZED_NAME.get(normalizeColorName(compositeCode.slice(prefix.length)));
};
